export const getLinkToAppPage = (slug: string) =>
  `${process.env.HTTP_PROTOCOL}://app.${process.env.ROOT_NETLOC}/${slug}`;

export const getLinkToLogin = () => `${process.env.HTTP_PROTOCOL}://app.${process.env.ROOT_NETLOC}/login`;
